import { useDispatch, useSelector } from 'react-redux';
import {
  setExchangeToken as setET,
  setSkipRToken as setSRT,
  restore,
} from './exchange.slice';

export default function useExchange() {
  const dispatch = useDispatch();
  const { exchangeToken, skipRToken } = useSelector((state) => state.exchange);

  const setExchangeToken = (token) => dispatch(setET(token));
  const setSkipRToken = (skip) => {
    return dispatch(setSRT(skip));
  };
  const clearExchangeToken = () => dispatch(restore());

  return {
    exchangeToken,
    skipRToken,
    setExchangeToken,
    setSkipRToken,
    clearExchangeToken,
  };
}
